import React, { Component } from 'react';

import { RequireAuth } from '@defi/core-ui';
import LoginContainer from './containers/LoginContainer';
import LoginContainerNew from './components/pages/LoginContainer';
import ForgotContainer from './components/forgotpw/ForgotContainer';
import Logout from './components/pages/Logout';
import SsoLogout from './components/pages/SsoLogout';
import NotFound from './components/pages/NotFound';
import { CAN_RESET_USER_PASSSWORD } from './constants/canPermissions';
import { PASSWORD_EXPIRED } from './constants/profileConditions';
import {
  // PATH_LOGIN_FULL,
  // PATH_LOGOUT_FULL,
  // PATH_EXPIRED_FULL,
  // PATH_CHANGE_PASSWORD_FULL,
  PATH_RESET_PASSWORD_FULL,
  // PATH_FORGOT_PASSWORD_FULL,
} from './paths';

// Require permissions to edit page
const requireEditAbility = false;
const ignorePermissionsCheck = true;

class LoginWrapper extends Component {
  render() {

    return <LoginContainer {...this.props} />;
  }
}

// Setup Routes
export const getRoutes = [
  {
    path: "/ui/login/",
    content: LoginContainerNew,
  },
  {
    path: "/ui/login/defilogin/",
    content: LoginContainerNew,
  },
  {
    path: "/ui/login/logout/",
    content: Logout,
  },
  {
    path: "/ui/login/ssologout/",
    content: SsoLogout,
  },
  {
    path: '/ui/login/forgot-password/',
    content: ForgotContainer,
  },
  {
    path: '/ui/login/expired/',
    form: 'expired',
    content: RequireAuth(LoginWrapper, requireEditAbility, ignorePermissionsCheck, {
      Profile: PASSWORD_EXPIRED,
    }),
  },
  {
    path: '/ui/login/change-password/',
    form: 'change-password',
    content: RequireAuth(LoginWrapper, requireEditAbility, ignorePermissionsCheck),
  },
  {
    path: PATH_RESET_PASSWORD_FULL,
    form: 'reset-password',
    content: RequireAuth(LoginWrapper, requireEditAbility, ignorePermissionsCheck, {
      Can: CAN_RESET_USER_PASSSWORD,
    }),
  },
  {
    path: '',
    content: NotFound,
  },
];